export interface Breakpoints {
    xs: string
    sm: string
    md: string
    lg: string
    xl: string
    xxl: string
}

export const xs: number = 320
export const sm: number = 480
export const md: number = 768
export const lg: number = 1024
export const xl: number = 1366
export const xxl: number = 1440

export const breakpoints: string[] & Breakpoints = Object.assign(
  [`${sm}px`, `${md}px`, `${lg}px`, `${xl}px`, `${xxl}px`],
  {
    default: '0px',
    xs: `${sm}px`,
    sm: `${sm}px`,
    md: `${md}px`,
    lg: `${lg}px`,
    xl: `${xl}px`,
    xxl: `${xxl}px`,
  },
)
